interface VisualizationFullscreenToggleIconProps {
  stroke?: string;
  fill?: string;
  width?: number;
  height?: number;
}

export function VisualizationFullscreenToggleIcon({
  stroke,
  fill = "#C0C0C0",
  width = 18,
  height = 18,
}: VisualizationFullscreenToggleIconProps) {
  const fillColor = stroke || fill;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.85 0.85L14.3 2.3L12.12 4.46C11.73 4.85 11.73 5.49 12.12 5.88C12.51 6.27 13.15 6.27 13.54 5.88L15.7 3.7L17.15 5.15C17.46 5.46 18 5.24 18 4.79V0.5C18 0.22 17.78 0 17.5 0H13.21C12.76 0 12.54 0.54 12.85 0.85ZM0.85 5.15L2.3 3.7L4.46 5.88C4.85 6.27 5.49 6.27 5.88 5.88C6.27 5.49 6.27 4.85 5.88 4.46L3.7 2.3L5.15 0.85C5.46 0.54 5.24 0 4.79 0H0.5C0.22 0 0 0.22 0 0.5V4.79C0 5.24 0.54 5.46 0.85 5.15ZM5.15 17.15L3.7 15.7L5.88 13.54C6.27 13.15 6.27 12.51 5.88 12.12C5.49 11.73 4.85 11.73 4.46 12.12L2.3 14.3L0.85 12.85C0.54 12.54 0 12.76 0 13.21V17.5C0 17.78 0.22 18 0.5 18H4.79C5.24 18 5.46 17.46 5.15 17.15ZM17.15 12.85L15.7 14.3L13.54 12.12C13.15 11.73 12.51 11.73 12.12 12.12C11.73 12.51 11.73 13.15 12.12 13.54L14.3 15.7L12.85 17.15C12.54 17.46 12.76 18 13.21 18H17.5C17.78 18 18 17.78 18 17.5V13.21C18 12.76 17.46 12.54 17.15 12.85Z"
        fill={fillColor}
      />
    </svg>
  );
}
